import { StripeCardForm } from './StripeCardForm';
import { BraintreeCardForm } from './BraintreeCardForm';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { useContext, useMemo } from 'react';
import { SaveCardCheckbox } from '../PaymentInputs/SaveCardCheckbox';
import { AdyenCardForm } from './AdyenCardForm';
import { NuveiCardForm } from './NuveiCardForm';
import { PayButton } from '../PaymentInputs/PayButton';
import { calculateTotalPrice } from '@/utils/pricing';
import { ApprovalText } from '../PaymentInputs/ApprovalText';

export const InitialCreditCardForm = () => {
  const {
    paymentMethodsSettings,
    card: { initialCardPayload, setInitialCardPayload },
    pricing,
    payment,
    actions: { runPayment },
  } = useContext(CheckoutContext);
  const cardSettings = paymentMethodsSettings.find((pm) => pm.paymentMethodName === PaymentMethodEnum.CREDIT_CARD);

  const Component = useMemo(() => {
    if (!cardSettings) return null;

    if (cardSettings.provider === ProviderEnum.STRIPE) {
      return <StripeCardForm />;
    }

    if (cardSettings.provider === ProviderEnum.BRAINTREE) {
      return <BraintreeCardForm />;
    }
    if (cardSettings.provider === ProviderEnum.ADYEN) {
      return <AdyenCardForm />;
    }
    if (cardSettings.provider === ProviderEnum.NUVEI) {
      return <NuveiCardForm />;
    }

    return null;
  }, [cardSettings]);

  const handleSaveCardChange = (value: boolean) => {
    setInitialCardPayload({ ...initialCardPayload, isSaveCard: value });
  };

  return (
    <div data-testid="initial-credit-card-form" className="flex flex-col gap-4">
      {Component}
      <div className="flex items-center w-full gap-2">
        <SaveCardCheckbox isSaveCard={initialCardPayload?.isSaveCard ?? false} setIsSaveCard={handleSaveCardChange} />
      </div>
      <div className="flex flex-col">
        <PayButton
          price={calculateTotalPrice(pricing)}
          isDisabled={!payment.isFormValid}
          onClick={() => {
            runPayment({ newCard: true });
          }}
        />
        <ApprovalText />
      </div>
    </div>
  );
};
